import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatDate, toQueryParams } from 'admin/utils';
import {
  getSoftwareProductCodes,
  getSoftwareTargetHardwares,
} from 'admin/actions/softwares';
import {
  getSoftwareReleases,
  clearSoftwareReleases,
} from 'admin/actions/software-releases';
import LabeledSelect from 'admin/components/molecules/LabeledSelect';
import _Select, { addNullOption } from 'admin/components/atoms/Select';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import Pager from 'admin/components/shared/Pager';
import { openAlertModal, closeAlertModal } from 'admin/actions/alert-modal';
import TestRunModalBody from './TestRunModalBody';

const LabelText = styled.span`
  font-weight: 600;
`;

const FilterBox = styled.div`
  ${LabeledSelect} {
    display: block;
    margin: 15px;
    float: left;
  }
  ${_Select} {
    margin-left: 15px;
    width: 200px;
  }
  button {
    margin: 15px;
    float: right;
  }
`;

const Hr = styled.hr`
  clear: both;
  border-bottom: 1px solid #CCC;
`;

const ListTable = styled.div`
  padding: 20px;
`;

const NoResultText = styled.span`
  font-weight: 600;
  font-size: 20px;
  padding: 10px;
  text-align: center;
  display: block;
`;

const unselect = { label: '選択して下さい', value: null };

class SoftwareReleases extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 20 };
    this.state = {
      selectedProductCode: unselect,
      selectedTargetHardware: unselect,
      currentPage: 1,
    };
  }

  componentWillMount() {
    this.props.getSoftwareProductCodes();
    this.props.clearSoftwareReleases();
  }

  refreshSoftwareReleases(state) {
    const params = Object.assign({}, this.defaultPagination, {
      productCode: state.selectedProductCode.value,
      targetHardware: state.selectedTargetHardware.value,
      page: state.currentPage,
    });
    this.props.getSoftwareReleases(toQueryParams(params, true));
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.selectedProductCode !== nextState.selectedProductCode ||
        this.state.selectedTargetHardware !== nextState.selectedTargetHardware) {
      if (this.state.selectedProductCode !== nextState.selectedProductCode) {
        if (nextState.selectedProductCode.value) {
          this.props.getSoftwareTargetHardwares(nextState.selectedProductCode.value).then(() => {
            this.setState({
              selectedTargetHardware: unselect,
            });
          });
        }
      }
      if (nextState.selectedProductCode.value && nextState.selectedTargetHardware.value) {
        this.refreshSoftwareReleases(nextState);
      } else {
        this.props.clearSoftwareReleases();
      }
    }
  }

  onChangeProductCode = (op) => {
    this.setState({
      selectedProductCode: op,
    });
  }

  onChangeTargetHardware = (op) => {
    this.setState({
      selectedTargetHardware: op,
    });
  }

  onChangePage = (page) => {
    this.setState({
      currentPage: page,
    }, () => this.refreshSoftwareReleases(this.state));
  }

  onClickedTestRun = () => {
    const productCode = this.state.selectedProductCode.value;
    const targetHardware = this.state.selectedTargetHardware.value;
    this.props.openAlertModal({
      body: (
        <TestRunModalBody
          productCode={productCode}
          targetHardware={targetHardware}
        />
      ),
      useCancel: true,
      useConfirm: false,
      styles: {
        content: {
          overflow: 'visible',
        },
      },
    });
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: 'サービス管理', href: '', active: true },
      { value: 'ソフトウェアリリース管理', href: '/service-settings/software-release', active: true },
    ];
    const columns = [
      { label: 'リリースの説明', align: 'center', size: 2.5 },
      { label: '有効', align: 'center', size: 0.3 },
      { label: '優先度', align: 'center', size: 0.3 },
      { label: '絞り込み条件', align: 'center', size: 1 },
      { label: '登録日時', align: 'center', size: 1 },
    ];
    const rows = this.props.softwareReleases.rows.map(row => [
      {
        data: (
          <Link to={`/service-settings/software-release/${row.id}`}>
            {row.description.length ? row.description : `ver: ${row.version_code}`}
          </Link>
        ),
        align: 'center',
      },
      { data: (<span>{row.is_enabled ? '有効' : '無効'}</span>), align: 'center' },
      { data: (<span>{row.priority}</span>), align: 'center' },
      {
        data: (
          <div>
            { row.organization_name ? <span>対象組織: {row.organization_name}</span> : null }
            { row.private_money_name ? <span>対象マネー: {row.private_money_name}</span> : null }
            { row.shop_name ? <span>対象店舗: {row.shop_name}</span> : null }
            { row.terminal_uuid ? <span>特定ターミナル: {row.terminal_uuid.slice(0, 8)}</span> : null }
            {
              (
                !row.organization_code &&
                !row.private_money_uuid &&
                !row.shop_uuid &&
                !row.terminal_uuid
              ) ? (
                <span>すべて</span>
              ) : null
            }
            <br />
            <span>対象割合: {row.available_rate}％</span><br />
            { row.available_from ? <span>開始日時: {formatDate(row.available_from)}</span> : null }
          </div>
        ),
        align: 'center',
      },
      { data: (<span>{formatDate(row.created_at)}</span>), align: 'center' },
    ]);
    const productCode = this.state.selectedProductCode.value;
    const targetHardware = this.state.selectedTargetHardware.value;
    const filterSelected = productCode && targetHardware;
    return (
      <div>
        <Breadcrumb items={crumb} />
        <FilterBox>
          <LabeledSelect
            labelText={(<LabelText>プロダクト</LabelText>)}
            options={
            addNullOption(this.props.softwareProductCodes.map(m => ({
              label: m,
              value: m,
            })), '選択して下さい')
            }
            value={this.state.selectedProductCode}
            onChange={this.onChangeProductCode}
          />
          <LabeledSelect
            labelText={(<LabelText>ハードウェア</LabelText>)}
            options={
            addNullOption(this.props.softwareTargetHardwares.map(m => ({
              label: m,
              value: m,
            })), '選択して下さい')
            }
            value={this.state.selectedTargetHardware}
            onChange={this.onChangeTargetHardware}
          />
          <Link to="/service-settings/software-release/create">
            <Button>
              新しいリリースを作成
            </Button>
          </Link>
          <Button onClick={this.onClickedTestRun} disabled={!filterSelected} color="gray">
            動作テスト
          </Button>
        </FilterBox>
        <Hr />
        {
          (!rows || rows.length === 0) ? (
            <NoResultText>結果がありません</NoResultText>
          ) : (
            <div>
              <ListTable>
                <TableHeader columns={columns} />
                <TableRows rows={rows} columns={columns} />
              </ListTable>
              <Pager
                pagination={this.props.softwareReleases.pagination}
                onChangePage={this.onChangePage}
              />
            </div>
          )
        }
      </div>
    );
  }
}

SoftwareReleases.defaultProps = {
  softwareReleases: { rows: [], count: 0, pagination: { current: 1, per_page: 30 } },
  softwareProductCodes: [],
  softwareTargetHardwares: [],
};

const mapStateToProps = state => ({
  softwareReleases: state.softwareRelease.softwareReleases,
  softwareProductCodes: state.software.softwareProductCodes,
  softwareTargetHardwares: state.software.softwareTargetHardwares,
});

SoftwareReleases.propTypes = {
  openAlertModal: PropTypes.func.isRequired,
  closeAlertModal: PropTypes.func.isRequired,
  getSoftwareProductCodes: PropTypes.func.isRequired,
  getSoftwareTargetHardwares: PropTypes.func.isRequired,
  getSoftwareReleases: PropTypes.func.isRequired,
  clearSoftwareReleases: PropTypes.func.isRequired,
  softwareProductCodes: PropTypes.arrayOf(PropTypes.string),
  softwareTargetHardwares: PropTypes.arrayOf(PropTypes.string),
  softwareReleases: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      product_code: PropTypes.string,
      target_hardware: PropTypes.string,
      version_code: PropTypes.string,
      is_enabled: PropTypes.bool,
      priority: PropTypes.number,
      available_rate: PropTypes.number,
      available_from: PropTypes.string,
      organization_code: PropTypes.string,
      organization_name: PropTypes.string,
      private_money_name: PropTypes.string,
      private_money_uuid: PropTypes.string,
      shop_name: PropTypes.string,
      shop_uuid: PropTypes.string,
      terminal_uuid: PropTypes.string,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
    })),
    count: PropTypes.number,
    pagination: PropTypes.shape({
      current: PropTypes.number,
      per_page: PropTypes.number,
    }),
  }),
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  openAlertModal,
  closeAlertModal,
  getSoftwareProductCodes,
  getSoftwareTargetHardwares,
  getSoftwareReleases,
  clearSoftwareReleases,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SoftwareReleases);
